<template>
  <div>
    <div class="file-button">
      <el-upload
        class="upload-button"
        :action="uploadUrl"
        :data="data"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        v-if="importButton"
      >
        <el-button
          size="small"
          :type="btnType"
          :plain="plain"
          v-loading.fullscreen.lock="fullscreenLoading"
          element-loading-text="导入中..."
          >{{ name }}</el-button
        >
      </el-upload>
      <el-button
        size="small"
        type="primary"
        :plain="plain"
        @click="handleExport()"
        v-if="exportButton"
        :loading="downloading"
        >{{ exportBtnName }}</el-button
      >
      <!-- <el-button
        size="small"
        type="primary"
        plain
        @click="handleExport(true)"
        v-if="importButton"
        >下载模板</el-button
      > -->
    </div>
  </div>
</template>

<script>
import { fileExport } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/index'

export default {
  props: {
    obj: {
      type: String,
      default: '',
    },
    importButton: {
      type: Boolean,
      default: true,
    },
    exportButton: {
      type: Boolean,
      default: true,
    },
    btnType: {
      type: String,
      default: 'primary',
    },
    plain: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
    },
    name: {
      type: String,
      default: '导入',
    },
    exportBtnName: {
      type: String,
      default: '导出',
    },
  },
  data() {
    return {
      downloading: false,
      fullscreenLoading: false,
      data: { obj: this.obj },
      uploadUrl: urlPerfix + '/files/import',
      uploadHeader: { Token: store.state.userInfo.token },
    }
  },
  methods: {
    handleUploadSuccess(res, file) {
      this.fullscreenLoading = false
      if (res.code != 0) {
        this.$message.error('导入失败，请刷新页面重试')
      } else {
        this.$message.success('导入成功！')
        this.$emit('importCallback', res)
      }
    },
    handleUploadError() {},
    beforeUpload() {
      this.fullscreenLoading = true
    },
    async handleExport(temp = false) {
      let data = {
        obj: this.obj,
        template: temp,
      }

      data = Object.assign(data, this.filter)

      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }

      if (data.settle_date && data.settle_date.length == 2) {
        data.settle_start_date = data.settle_date[0]
        data.settle_end_date = data.settle_date[1]
      }

      if (data.start_date && data.start_date.length == 2) {
        data.start_date1 = data.start_date[0]
        data.end_date1 = data.start_date[1]
      }

      if (data.end_date && data.end_date.length == 2) {
        data.start_date2 = data.end_date[0]
        data.end_date2 = data.end_date[1]
      }

      if (!temp) {
        this.downloading = true
      }
      let res = await fileExport(data)
      if (res.code == 0 && res.data) {
        if (res.data.includes('?v=')) {
          res.data = res.data.split('?')[0]
        }
        window.location.href = res.data
      }
      this.downloading = false
    },
  },
}
</script>

<style>
.el-upload__input {
  display: none !important;
}
</style>

<style scoped>
.upload-button {
  margin-right: 10px;
}
.file-button {
  display: flex;
}
</style>